import React from 'react';
import { Label } from './Label';
import { LabelSheet as LabelSheetType } from '../types/LabelLayout';
import '../styles/print.css';

interface LabelSheetProps {
    /** Sheet data containing 24 label slots */
    sheet: LabelSheetType;
}

/**
 * LabelSheet component - renders an A4 sheet with 3×8 grid of labels.
 *
 * Each sheet holds exactly 24 labels (3 columns × 8 rows).
 * Empty slots are rendered as empty labels on screen and hidden in print.
 */
export const LabelSheet: React.FC<LabelSheetProps> = ({ sheet }) => {
    return (
        <div className="label-sheet">
            {sheet.labels.map((item, index) => (
                <Label
                    key={`label-${sheet.sheetNumber}-${index}`}
                    item={item}
                    cellIndex={index + 1}
                />
            ))}
        </div>
    );
};
